import Vue from "vue";
import Router from "vue-router";
import store from "./store";

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
	if (!store.getters[`user/isAuthenticated`]) {
		next();
		return;
	}
	next("/");
};

const autoRedirect = (to, from, next) => {
	if (store.getters[`user/isAuthenticated`]) {
		const role = store.getters[`user/role`];
		if (role) {
			next(`/${role}`);
			return;
		}
	}
	next("/login");
};

const ifAuthenticated = (to, from, next) => {
	if (store.getters[`user/isAuthenticated`]) {
		store.dispatch(`user/checkAuth`)
			.then(() => next())
			.catch((err) => {
				console.log(`ifAuthentiated`, err)
				next("/login")
			})
	}
	else{
		next("/login");
	}
};

const ifAuthenticatedExaminee = (to, from, next) => {
	if (store.getters[`user/isAuthenticated`] && store.getters[`user/roleId`]) {
		store.dispatch(`user/checkAuth`)
			.then(res => {
				if(res)
					return store.dispatch(`examinee/getStatus`, {id : store.getters[`user/roleId`]})
				else
					throw new Error()
			})
			.then((status) =>{
				var intendedPath
				switch(status){
					case "created":
						intendedPath = "/examinee/termsandconditions"
						break;
					case "agreementsigned":
						intendedPath = "/examinee/info"
						break;
					case "personalinfogiven":
						intendedPath = "/examinee/reminder"
						break;
					case "reminderaccepted":
						intendedPath = "/examinee/test"
						break;
					case "completed":
						intendedPath = "/examinee/result"
						break;
					case "locked":
						intendedPath = "/examinee/locked"
						break;
				}
				if(to.fullPath == intendedPath){
					intendedPath = null
				}
				if(intendedPath){
					return next(intendedPath)
				}
				else{
					return next()
				}
			})
			.catch((err) => { 
				console.log('ifAuthenticatedExaminee err ', err)
				next("/login")
			})
	}
	else{
		next("/login");
	}
};

export default new Router({
	mode: "history",
	routes: [
		{
			title: 'Login - PPC Test',
			path: "/login",
			name: "login",
			component: () => import("./pages/LoginPage.vue"),
			beforeEnter: ifNotAuthenticated,
		},
		{
			title: 'PPC Test',
			path: "/",
			beforeEnter: autoRedirect,
		},
		{
			title: 'PPC Test',
			path: "/admin",
			name: "admin",
			component: () => import("./pages/AdminPage.vue"),
			beforeEnter: ifAuthenticated,
			children: [
				{
					title: 'PPC Test',
					path: "clients",
					alias: "/admin",
					name: "AdminClients",
					component: () => import("./components/admin/ClientList.vue"),
          beforeEnter: ifAuthenticated,
        },
        {
					title: 'PPC Test',
          path: "clients/:id",
          name: "ClientView",
          component: () => import("./components/admin/ClientView.vue"),
          props: true,
          beforeEnter: ifAuthenticated,
				},
				{
					title: 'PPC Test',
					path: "exams",
					name: "AdminExams",
					component: () => import("./components/admin/ExamList.vue"),
          beforeEnter: ifAuthenticated,
        },
				{
					title: 'PPC Test',
					path: "settings",
					name: "AdminSettings",
					component: () => import("./components/admin/ClientList.vue"),
					beforeEnter: ifAuthenticated,
				},
			],
		},
		{
			title: 'Client - PPC Test',
			path: "/client",
			name: "client",
			component: () => import("./pages/ClientPage.vue"),
			beforeEnter: ifAuthenticated,
			children: [
				{
					title: 'PPC Test',
					path: "examinees",
					alias: "/client",
					name: "ClientExaminees",
					component: () => import("./components/client/ClientDashboard.vue"),
					beforeEnter: ifAuthenticated,
				},
				{
					title: 'PPC Test',
					path: "settings",
					name: "ClientSettings",
					component: () => import("./components/client/ExamineeList.vue"),
					beforeEnter: ifAuthenticated,
				},
			],
		},
		{
			title: 'PPC Test',
			path: "/examinee",
			name: "examinee",
			component: () => import("./pages/ExamineePage.vue"),
			beforeEnter: ifAuthenticatedExaminee,
			children: [
				{
					title: 'PPC Test',
					path: "termsandconditions",
					name: "ExamineeTermsAndConditions",
					component: () => import("./components/examinee/ExamineeTermsAndConditions.vue"),
          beforeEnter: ifAuthenticatedExaminee,
				},
				{
					title: 'PPC Test',
					path: "info",
					name: "ExamineePersonalInfo",
					component: () => import("./components/examinee/ExamineePersonalInfo.vue"),
          beforeEnter: ifAuthenticatedExaminee,
        },
				{
					title: 'PPC Test',
					path: "reminder",
					name: "ExamineeNoCheatReminder",
					component: () => import("./components/examinee/ExamineeNoCheatReminder.vue"),
          beforeEnter: ifAuthenticatedExaminee,
        },
				{
					title: 'PPC Test',
					path: "test",
					name: "ExamineeTest",
					component: () => import("./components/examinee/ExamineeTest.vue"),
          beforeEnter: ifAuthenticatedExaminee,
				},
				{
					title: 'PPC Test',
					path: "locked",
					name: "ExamineeLocked",
					component: () => import("./components/examinee/ExamineeLocked.vue"),
					beforeEnter: ifAuthenticatedExaminee,
				},
				{
					title: 'PPC Test',
					path: "result",
					name: "ExamineeResult",
					component: () => import("./components/examinee/ExamineeResult.vue"),
          beforeEnter: ifAuthenticatedExaminee,
        },
			],
		},
	],
});
